"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.Root = exports.LoginSection = exports.Inner = exports.Image = exports.ContactBrandPartnerInfo = exports.Button = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../../containers/CategoryPage/styles");
const Root = exports.Root = (0, _mui.styled)(_styles.Root)((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        textAlign: 'center'
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(0, 'auto'),
        maxWidth: 450,
        padding: theme.spacing(6, 2, 9)
    };
});
const Title = exports.Title = (0, _mui.styled)('h1')((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(9),
        fontSize: '2.5rem',
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: '3.5rem',
        [theme.breakpoints.up(768)]: {
            marginBottom: theme.spacing(6)
        }
    };
});
const Image = exports.Image = (0, _mui.styled)('img')((param)=>{
    let { theme } = param;
    return {
        height: 80,
        marginBottom: theme.spacing(3),
        maxWidth: '100%',
        verticalAlign: 'middle'
    };
});
const Button = exports.Button = (0, _mui.styled)('a')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        border: "2px solid ".concat(theme.palette.grey.A700),
        borderRadius: '23px',
        boxSizing: 'border-box',
        color: theme.palette.grey.A700,
        cursor: 'pointer',
        display: 'flex',
        fontSize: '1.4rem',
        fontWeight: theme.typography.fontWeightBold,
        height: 45,
        justifyContent: 'center',
        margin: theme.spacing(0, 'auto'),
        textTransform: 'uppercase',
        width: 300
    };
});
const LoginSection = exports.LoginSection = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        marginTop: theme.spacing(12),
        position: 'relative',
        textAlign: 'center',
        width: '100%',
        '&:before': {
            backgroundColor: theme.palette.grey[200],
            content: '""',
            height: 2,
            position: 'absolute',
            top: -28,
            width: '100%',
            [theme.breakpoints.up(768)]: {
                top: -43
            }
        },
        [theme.breakpoints.up(768)]: {
            marginTop: theme.spacing(18)
        }
    };
});
const ContactBrandPartnerInfo = exports.ContactBrandPartnerInfo = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        fontSize: '1.4rem',
        marginBottom: theme.spacing(6),
        maxWidth: 300
    };
});
